import type { Player } from '@dicetechnology/doris-core';

import { DiceReceiverManager } from '../services';

import { throwError } from './throwError';

export const configureConvivaPlugin = async (player: Player): Promise<void> => {
    const CONVIVA_PLUGIN_NAME = 'conviva';

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const { convivaCustomerKey } = diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    // If the plugin is not yet added, only proceed if convivaCustomerKey exists.
    if (!convivaCustomerKey || player.getPluginByName(CONVIVA_PLUGIN_NAME)) {
        return;
    }

    const { ConvivaPlugin, ConvivaDeviceCategory, ConvivaDeviceType } = await import('@dicetechnology/doris-plugin-conviva');

    const existingPlugin = player.getPluginByType(ConvivaPlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: CONVIVA_PLUGIN_NAME,
            Plugin: ConvivaPlugin,
            config: {
                customerKey: convivaCustomerKey,
                deviceCategory: ConvivaDeviceCategory.CHROMECAST,
                deviceType: ConvivaDeviceType.SETTOP
            }
        });
    }
};
